import { apiFetch } from "../../api/apiFetch";
﻿
export async function getVideoLibraries(appid) {
    var url = "/api/video/getlibraries?appid=" + appid;
    const response = await apiFetch(url);
    if (response.status !== 200) 
        return "error";
    const data = await response.json();
    if (data)
        return data;
    return null;
}

export async function getVideoLibrary(id) {
    const response = await apiFetch("/api/video/getlibrary?id=" + id);
    if (response.status !== 200)
        return "error";
    const data = await response.json();
    if (data)
        return data;
    return null;
}

export async function getRumbleVideo(id) {
    const response = await apiFetch("/api/video/getrumblevideo?id=" + id);
    if (response.status !== 200)
        return "error";
    const data = await response.json();
    if (data)
        return data;
    return null;
}


export async function newLibrary(title, parentID, appid) {
    const req = {
        ParentID: parentID,
        Title: title,
        AppID: appid
    };
    const response = await apiFetch("/api/video/createlibrary", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        const library = await response.json();
        return library;
    }
    return null;
}

export async function editLibrary(id, title) {
    const req = {
        ID: id,
        Title: title
    };
    const response = await apiFetch("/api/video/editlibrary", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        const success = await response.json();
        return success;
    }
   // console.error(response);
    return false;
}

export async function deleteLibrary(id) {
    const req = {
        ID: id,
    };
    const response = await apiFetch("/api/video/deletelibrary", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        const success = await response.json();
        return success;
    }
   // console.error(response);
    return false;
}
export async function updateCover(id, photoid) {
    const req = {
        ID: id,
        PhotoID: photoid
    };
    const response = await apiFetch("/api/video/updatecover", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        const success = await response.json();
        return success;
    }
    //console.error(response);
    return false;
}
export async function saveRumbleVideo(title, parentID, rumbleID, rumbleURL, appid) {
    const req = {
        ParentID: parentID,
        Title: title,
        RumbleID: rumbleID,
        RumbleURL: rumbleURL,
        AppID: appid
    };
    const response = await apiFetch("/api/video/saverumblevideo", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        const library = await response.json();
        return library;
    }
    return null;
}

export async function editRumbleVideo(id, title, parentID, rumbleID, rumbleURL) {
    const req = {
        ID: id,
        ParentID: parentID,
        Title: title,
        RumbleID: rumbleID,
        RumbleURL: rumbleURL
    };
    const response = await apiFetch("/api/video/editrumblevideo", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        const library = await response.json();
        return library;
    }
    return null;
}
export async function deleteRumbleVideo(id) {
    const req = {
        ID: id,
    };
    const response = await apiFetch("/api/video/deleterumblevideo", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        const library = await response.json();
        return library;
    }
    return null;
}

export async function saveVideo(file, parentID, appid, cover) {

    const formData = new FormData();
    formData.append('file', file);
    formData.append('parentid', parentID);
    formData.append('appid', appid);
    formData.append('coverB64', cover);

    const vidID = await apiFetch('/api/video/savevideo', {
        method: 'POST',
        body: formData
    }).then(
        response => response.json()
    );
    return vidID;
}



export async function saveVideoAPI(file, parentID, appid, coverB64, accessToken, userID) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("parentid", parentID);
    formData.append("appid", appid);
    formData.append("userid", userID);          // required by API today
    formData.append("coverB64", coverB64 ?? "");

    const res = await apiFetch("/api/video/savevideo", {
        method: "POST",
        body: formData,
        token: accessToken,
    });

    if (!res.ok) {
        const errText = await res.text().catch(() => "");
        throw new Error(`SaveVideo failed (${res.status}): ${errText}`);
    }

    // API returns Ok(id) -> might be plain guid text OR JSON string ("guid")
    const text = await res.text();
    try {
        return JSON.parse(text);
    } catch {
        return text;
    }
}

export async function deleteVideo(id) {
    const req = {
        ID: id,
    };
    const response = await apiFetch("/api/video/deletevideo", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        const success = await response.json();
        return success;
    }
    // console.error(response);
    return false;
}
export async function moveVideo(id, parentid) {
    const req = {
        ID: id,
        ParentID: parentid
    };
    const response = await apiFetch("/api/video/movevideo", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        const success = await response.json();
        return success;
    }
    // console.error(response);
    return false;
}
export async function getVideo(id) {
    const response = await apiFetch("/api/video/getvideo?id=" + id);
    if (response.status !== 200)
        return "error";
    const data = await response.json();
    if (data)
        return data;
    return null;
}